export function getPersonName(person, fallback = 'بدون نام') {
  return [person?.firstName, person?.lastName].filter(Boolean).join(' ') || fallback;
}

export function getTeacherName(teacher) {
  return getPersonName(teacher, 'معلم');
}

export function getClassFromItem(item) {
  if (!item) {
    return null;
  }

  return item.class || item.classSubject?.class || item.classes?.[0] || null;
}

export function getSubjectFromItem(item) {
  if (!item) {
    return null;
  }

  return item.subject || item.classSubject?.subject || null;
}

export function getTeacherFromItem(item) {
  if (!item) {
    return null;
  }

  return item.teacher || item.classSubject?.teacher || null;
}

export function getClassSubjectId(item) {
  return item?.classSubjectId || item?.classSubject?.id || null;
}

export function getClassTitle(item, fallback = 'کلاس') {
  return getClassFromItem(item)?.title || fallback;
}

export function getSubjectTitle(item, fallback = '') {
  return getSubjectFromItem(item)?.title || fallback;
}

export function formatClassSubjectLine(item, { includeTeacher = true, fallbackClass = 'کلاس' } = {}) {
  const classTitle = getClassTitle(item, fallbackClass);
  const subjectTitle = getSubjectTitle(item);
  const teacherName = includeTeacher ? getTeacherName(getTeacherFromItem(item)) : '';

  return [classTitle, subjectTitle, includeTeacher ? teacherName : ''].filter(Boolean).join(' | ');
}

export function normalizeClassSubject(item, classItem = null) {
  if (!item) {
    return null;
  }

  const subject = item.subject || {
    id: item.subjectId || item.id,
    title: item.title || item.name || item.subjectTitle || '',
  };
  const teacher = item.teacher || null;
  const classInfo = item.class || classItem || null;

  return {
    id: item.id || item.classSubjectId,
    classId: item.classId || classInfo?.id || null,
    subjectId: item.subjectId || subject?.id || null,
    teacherId: item.teacherId || teacher?.id || null,
    class: classInfo,
    subject: subject?.id || subject?.title ? subject : null,
    teacher,
  };
}

export function getClassSubjects(classItem) {
  const rawSubjects = classItem?.subjects || classItem?.classSubjects || [];

  return rawSubjects
    .map((item) => normalizeClassSubject(item, classItem))
    .filter((item) => item?.id);
}

export function flattenClassSubjects(classes = []) {
  return classes.flatMap((classItem) => getClassSubjects(classItem));
}

export function formatSubjectTitles(classItem) {
  return getClassSubjects(classItem)
    .map((classSubject) => classSubject.subject?.title)
    .filter(Boolean)
    .join('، ');
}

export function formatClassSubjectOptionLabel(classSubject) {
  const subjectTitle = classSubject?.subject?.title || 'درس';
  const classTitle = classSubject?.class?.title;

  return classTitle ? `${subjectTitle} · ${classTitle}` : subjectTitle;
}
